export default function HeroSection() {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          alt="Premium PVC vloer installatie in modern Amsterdam appartement - elegante visgraat PVC vloer met warme houtlook in ruime woonkamer"
          className="w-full h-full object-cover object-top"
          src="https://readdy.ai/api/search-image?query=Premium%20PVC%20flooring%20installation%20in%20modern%20Amsterdam%20apartment%20elegant%20herringbone%20pattern%20warm%20wood%20look%20spacious%20living%20room%20natural%20light%20contemporary%20design%20clean%20minimalist%20interior%20photography%20high%20quality%20serene%20atmosphere%20neutral%20earth%20tones"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-12 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 sm:px-6 py-2 mb-6 sm:mb-8">
          <i className="ri-shield-check-line text-brass-400 text-base sm:text-lg"></i>
          <span className="text-white text-xs sm:text-sm font-medium">
            <strong>Erkend vloerspecialist</strong> in Amsterdam
          </span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light text-white mb-4 sm:mb-6 tracking-tight leading-tight">
          <strong>PVC Vloeren</strong> voor<br className="hidden sm:block" />
          Elke Ruimte
        </h1>

        <p className="text-base sm:text-lg md:text-xl text-white/90 mb-8 sm:mb-12 max-w-2xl mx-auto font-light">
          <strong>Vakkundig gelegd</strong> door ervaren vloerspecialisten.<br className="hidden md:block" />
          Van advies tot eindresultaat, <strong>alles uit één hand</strong>.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-12 sm:mb-16">
          <a
            href="#offerte"
            className="group bg-brass-500 hover:bg-brass-600 text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg font-medium transition-all duration-300 flex items-center justify-center gap-2 hover:scale-105 whitespace-nowrap"
          >
            Gratis offerte aanvragen
            <i className="ri-arrow-right-line text-lg sm:text-xl group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href="#services"
            className="group bg-white/10 backdrop-blur-md hover:bg-white/20 text-white border border-white/30 px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg font-medium transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap"
          >
            Bekijk collecties
            <i className="ri-grid-line text-lg"></i>
          </a>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-white/90">
          <div className="flex items-center gap-2">
            <div className="flex">
              <i className="ri-star-fill text-brass-400 text-sm sm:text-base"></i>
              <i className="ri-star-fill text-brass-400 text-sm sm:text-base"></i>
              <i className="ri-star-fill text-brass-400 text-sm sm:text-base"></i>
              <i className="ri-star-fill text-brass-400 text-sm sm:text-base"></i>
              <i className="ri-star-fill text-brass-400 text-sm sm:text-base"></i>
            </div>
            <span className="text-xs sm:text-sm font-medium">4.9/5 (4.200+ reviews)</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-brass-400 text-lg sm:text-xl"></i>
            <span className="text-xs sm:text-sm font-medium"><strong>15 jaar garantie</strong></span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-team-line text-brass-400 text-lg sm:text-xl"></i>
            <span className="text-xs sm:text-sm font-medium">4.200+ gelegde vloeren</span>
          </div>
        </div>
      </div>

      {/* Bottom info bar */}
      <div className="absolute bottom-4 sm:bottom-8 left-4 right-4 sm:left-6 sm:right-6 z-20">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row gap-2 sm:gap-4 justify-center">
          <div className="backdrop-blur-md bg-white/10 px-4 sm:px-6 py-3 sm:py-4 rounded-xl border border-white/20">
            <p className="text-white text-xs sm:text-sm font-medium text-center">
              <strong>Vanaf €28/m²</strong> incl. <strong>leggen & ondervloer</strong>
            </p>
          </div>
          <div className="backdrop-blur-md bg-white/10 px-4 sm:px-6 py-3 sm:py-4 rounded-xl border border-white/20">
            <p className="text-white text-xs sm:text-sm font-medium text-center">
              1-3 weken levertijd • <strong>15 jaar garantie</strong>
            </p>
          </div>
          <div className="backdrop-blur-md bg-white/10 px-4 sm:px-6 py-3 sm:py-4 rounded-xl border border-white/20">
            <p className="text-white text-xs sm:text-sm font-medium text-center">
              Gratis advies & opmeting
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}